import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { featureKey, reducer } from "./claim.reducer";

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(featureKey, reducer)],
  providers: [],
})
export class ClaimStoreModule {}
